import UrlGeneration from "../libs/UrlGeneration";

export default new (class {
    constructor() {
        this.initHandler()
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.addEventListener("DOMContentLoaded", () => {
            document.querySelector('.select#sorting .select__input').addEventListener('change', (e) => {
                let sort = e.target.value;

                UrlGeneration.remove('sort');
                UrlGeneration.set('sort', sort);
                UrlGeneration.update();

                oc.ajax("ArticleList::onAjaxRequest", {
                    update: {
                        'pagination/pagination-items': `#pagination-items-article-list`,
                        'article/article-list': `#article-list`
                    }
                });
            })
        });
    }
})()
